import { useRef } from "react";
import { useAtom } from "jotai";

import { MobileTopNav } from "@/components/molecules/MobileTopNav";
import { MobileBottomNav } from "@/components/molecules/MobileBottomNav";
import { BrowsePage } from "@/components/pages/BrowsePage";
import { isModalOpenAtom } from "@/constants/atoms";
import { useClassNames } from "@/utils/classNames";

import styles from "./Mobile.module.scss";

function Mobile() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isModalOpen] = useAtom(isModalOpenAtom);

  const cn = useClassNames(
    styles,
    styles["mobile"],
    isModalOpen && styles["modal-open"],
  );

  return (
    <div className={styles["mobile"]} ref={scrollContainerRef}>
      <MobileTopNav />
      <BrowsePage
        slug="/home"
        fetchTileDetails={true}
        skipPersonalized={true}
        showMobileContent={true}
        enableLazyLoading={true}
        batchSize={5}
        initialBatchSize={3}
        loadThreshold={800}
        scrollContainerRef={scrollContainerRef}
      />

      <MobileBottomNav />
    </div>
  );
}

export { Mobile };
